const parseXml = (sourceXml, sourceElement) => {
    const domParser = new DOMParser();
    const xml = domParser.parseFromString(sourceXml, "text/xml")
    return xml.querySelector(sourceElement)
}

export { parseXml }
